// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#skills {
    overflow: hidden;
    width: 100vw;
    max-width: 65rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
}

.skillTitle {
    font-size: 3rem;
    font-weight: 600;
    padding-top: 3rem;
    margin-bottom: 1.5rem;
}

.skillDesc {
    font-weight: 400;
    font-size: 1rem;
    max-width: 51rem;
    padding: 0 2rem;
}

.skillBars {
    margin: 1.5rem;
    width: 100vw;
    max-width: 80%;
    text-align: left;
}

.skillBar {
    display: flex;
    margin: 1rem;
    padding: 1.5rem 2rem;
    border-radius: 0.5rem;
    background: rgb(50, 50, 50);
}

.skillBarImg {
    object-fit: cover;
    height: 3rem;
    width: 3rem;
    margin-right: 2rem;
}

.skillBarText>p {
    font-size: 0.9rem;
    font-weight: 200;
}

@media screen and (max-width:720px) {
    .skillBarText>p {
        font-size: 2vw;
    }
}

@media screen and (max-width:480px) {
    .skillBarText>p {
        font-size: 3vw;
    }
    .skillBarImg {
        height: 2.25rem;
        width: 2.25rem;
    }
    .skillBarText>h2 {
        font-size: 5vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Skills/skills.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;IACA;QACI,eAAe;QACf,cAAc;IAClB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":["#skills {\n    overflow: hidden;\n    width: 100vw;\n    max-width: 65rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    margin: 0 auto;\n}\n\n.skillTitle {\n    font-size: 3rem;\n    font-weight: 600;\n    padding-top: 3rem;\n    margin-bottom: 1.5rem;\n}\n\n.skillDesc {\n    font-weight: 400;\n    font-size: 1rem;\n    max-width: 51rem;\n    padding: 0 2rem;\n}\n\n.skillBars {\n    margin: 1.5rem;\n    width: 100vw;\n    max-width: 80%;\n    text-align: left;\n}\n\n.skillBar {\n    display: flex;\n    margin: 1rem;\n    padding: 1.5rem 2rem;\n    border-radius: 0.5rem;\n    background: rgb(50, 50, 50);\n}\n\n.skillBarImg {\n    object-fit: cover;\n    height: 3rem;\n    width: 3rem;\n    margin-right: 2rem;\n}\n\n.skillBarText>p {\n    font-size: 0.9rem;\n    font-weight: 200;\n}\n\n@media screen and (max-width:720px) {\n    .skillBarText>p {\n        font-size: 2vw;\n    }\n}\n\n@media screen and (max-width:480px) {\n    .skillBarText>p {\n        font-size: 3vw;\n    }\n    .skillBarImg {\n        height: 2.25rem;\n        width: 2.25rem;\n    }\n    .skillBarText>h2 {\n        font-size: 5vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
